import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { compose, withProps, branch, renderNothing, withHandlers } from 'recompose';

import TimeplanWeek from './TimeplanWeek';
import { getWeekIdentifiersForDates } from '../../../lib/dates';
import getTimeplanUnitsByWeek from './getTimeplanUnitsByWeek';
import Button from '../../Button';
import withHolidays from './withHolidays';
import { useTranslation } from 'react-i18next';

function Timeplan({
  dates,
  timeplanUnits,
  weekIdentifiersForSelectedDates,
  timeplanUnitsByWeekIdentifier,
  useIndicate,
  hasIndicateHandle,
  switchIndicate,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {useIndicate && (
        <Button onClick={switchIndicate} size="xs">
          {hasIndicateHandle ? t('Avmarkera') : t('Markera')} {t("alla dagar")}
        </Button>
      )}
      {weekIdentifiersForSelectedDates.map(weekIdentifier => (
        <TimeplanWeek
          key={weekIdentifier}
          selectedDates={dates}
          timeplanUnits={timeplanUnitsByWeekIdentifier.get(weekIdentifier, new List())}
          weekIdentifier={weekIdentifier}
          allTimeplanUnits={timeplanUnits}
          useIndicate={useIndicate}
          {...props}
        />
      ))}
    </React.Fragment>
  );
}

Timeplan.propTypes = {
  dates: PropTypes.instanceOf(List).isRequired,
  timeplanUnits: PropTypes.instanceOf(List).isRequired,
  useIndicate: PropTypes.bool.isRequired,
  hasIndicateHandle: PropTypes.bool.isRequired,
  switchIndicate: PropTypes.func.isRequired,
};

export default compose(
  branch(({ dates }) => !List.isList(dates), renderNothing),
  withHolidays,
  withProps(({ dates, timeplanUnits }) => ({
    weekIdentifiersForSelectedDates: getWeekIdentifiersForDates(dates.toJS()),
    timeplanUnitsByWeekIdentifier: getTimeplanUnitsByWeek(timeplanUnits),
  })),
  branch(useIndicate => useIndicate,
    compose(
      withProps(({ timeplanUnits }) => ({
        hasIndicateHandle: !!timeplanUnits.find(({ indicateHandle }) => !!indicateHandle),
      })),
      withHandlers({
        switchIndicate: ({
          timeplanUnits,
          mileageAllowances,
          onChangeTimeplanUnits,
        }) => () => {
          const tpusAndMileageAllowances = timeplanUnits.concat(mileageAllowances);
          const hasIndicateHandle = !!tpusAndMileageAllowances.find(({ indicateHandle }) => !!indicateHandle);
          const newTimeplanUnits = tpusAndMileageAllowances
            .map(tpu => tpu.set('indicateHandle', !hasIndicateHandle));
          const transformFunc = (o, tpus) => tpus;
          onChangeTimeplanUnits(transformFunc, newTimeplanUnits);
        },
      }),
    ),
  ),
)(Timeplan);
